import React from 'react';
import Head from 'next/head';
import { Helmet } from 'react-helmet-async';
import { useRouterContext } from 'hooks/use-router-context';
/**
 * Returns the head-manager component (next/head's `Head`, or react-helmet's
 * `Helmet`) for whichever tree this is currently rendering in. Some
 * components (e.g. SearchMeta) are shared between the Next.js app and the
 * legacy CRA app, and each tree only has one of the two head managers wired.
 */
export const useHeadComponent = () => {
    const nextRouter = useRouterContext();
    return nextRouter ? Head : Helmet;
};
export const withHeadComponent = WrappedComponent => {
    const WithHeadComponent = props => {
        const HeadComponent = useHeadComponent();
        return <WrappedComponent {...props} HeadComponent={HeadComponent}/>;
    };
    WithHeadComponent.displayName = `WithHeadComponent(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return WithHeadComponent;
};
